'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', 'MunicipalityService',
                function($scope, MunicipalityService) {
                    $scope.municipalities = [];
                    MunicipalityService.api.get({
                                                    filters: [`'status' EQ 'ENABLED'`],
                                                    sorts: ['npp:ASC', 'name:ASC'],
                                                }, (data) => $scope.municipalities = data._embedded);
                }];
